export default __webpack_public_path__ + "dc15f45f0b323f48ac81e31eb550320a.png";